import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance_0,
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
} from '../statement/HttpResponsePipeline.mjs';
import {
  platformResponseDefaultTransformers258gm9ywvn5cc as platformResponseDefaultTransformers,
  platformRequestDefaultTransformv8a3p2llr8mo as platformRequestDefaultTransform,
} from './DefaultTransform.web.mjs';
import {
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Application_getInstance2wn6cl3kv21f0 as Application_getInstance,
  Text_getInstancereo9eglzqyxz as Text_getInstance,
  Companion_getInstance1co6rysm0hsdc as Companion_getInstance,
  MultiPart_getInstance1qrv90sa9uvz5 as MultiPart_getInstance,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toLongkk4waq8msp1k as toLong,
  toInt2q8uldh7sc951 as toInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contentType2zzm38yxo3syt as contentType,
  contentLength2suzxu1lzutku as contentLength,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  canceldn4b3cdqcfny as cancel,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isByteArray4nnzfn1x4o3w as isByteArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  copyTo2si6ixg3c5rjz as copyTo,
  toByteArray39hw81iegcnuw as toByteArray,
  readRemaining1u8soafhjma7y as readRemaining,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  cancel2ztysw4v4hav6 as cancel_0,
  cancel36mj9lv3a0whl as cancel_1,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  WriterScope3b0bo1enaee6b as WriterScope,
  writer1eia5its2a1fh as writer,
  invokeOnCompletion1ziuxzoag0iwj as invokeOnCompletion,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CIOMultipartDataBase3o5u8w437tq5s as CIOMultipartDataBase } from '../../../../../ktor-ktor-http-cio/io/ktor/http/cio/CIOMultipartDataBase.mjs';
import { MultiPartData57syw40llxls as MultiPartData } from '../../../../../ktor-ktor-http/io/ktor/http/content/Multipart.mjs';
import { HttpStatusCode3o1wkms10pg4k as HttpStatusCode } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  Key_instance2rlngjw9v1qsd as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from '../call/utils.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { Source1shr0ps16u4p4 as Source } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Source.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultTransform_kt__20knxx();
  return LOGGER;
}
var LOGGER;
function defaultTransformers(_this__u8e3s4) {
  _init_properties_DefaultTransform_kt__20knxx();
  var tmp = Phases_getInstance().u5n_1;
  _this__u8e3s4.g5h_1.s4s(tmp, defaultTransformers$slambda_0());
  var tmp_0 = Phases_getInstance_0().r5i_1;
  _this__u8e3s4.h5h_1.s4s(tmp_0, defaultTransformers$slambda_2(_this__u8e3s4));
  platformResponseDefaultTransformers(_this__u8e3s4);
}
var defaultTransformers$2$content$1Class;
function defaultTransformers$2$content$1() {
  if (defaultTransformers$2$content$1Class === VOID) {
    class $ extends ByteArrayContent() {
      constructor($contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.g5q_1 = $body;
        super($box);
        var tmp = this;
        tmp.e5q_1 = $contentType == null ? Application_getInstance().y4u_1 : $contentType;
        this.f5q_1 = fromInt($body.length);
      }
      w47() {
        return this.e5q_1;
      }
      x47() {
        return this.f5q_1;
      }
      i57() {
        return this.g5q_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$2$content$1Class = $;
  }
  return defaultTransformers$2$content$1Class;
}
var defaultTransformers$2$content$2Class;
function defaultTransformers$2$content$2() {
  if (defaultTransformers$2$content$2Class === VOID) {
    class $ extends ReadChannelContent() {
      constructor($this_intercept, $contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.k5q_1 = $body;
        super($box);
        var tmp = this;
        var tmp0_safe_receiver = $this_intercept.o4s_1.e5j_1.k2o('Content-Length');
        tmp.i5q_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
        var tmp_0 = this;
        tmp_0.j5q_1 = $contentType == null ? Application_getInstance().y4u_1 : $contentType;
      }
      x47() {
        return this.i5q_1;
      }
      w47() {
        return this.j5q_1;
      }
      l57() {
        return this.k5q_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$2$content$2Class = $;
  }
  return defaultTransformers$2$content$2Class;
}
var defaultTransformers$slambdaClass;
function defaultTransformers$slambda() {
  if (defaultTransformers$slambdaClass === VOID) {
    class $ {
      *z5g($this$intercept, body, $completion) {
        if ($this$intercept.o4s_1.e5j_1.k2o('Accept') == null) {
          $this$intercept.o4s_1.e5j_1.o4p('Accept', '*/*');
        }
        var contentType_0 = contentType($this$intercept.o4s_1);
        var tmp;
        if (typeof body === 'string') {
          tmp = new (TextContent())(body, contentType_0 == null ? Text_getInstance().b4w_1 : contentType_0);
        } else {
          if (isByteArray(body)) {
            tmp = new (defaultTransformers$2$content$1())(contentType_0, body);
          } else {
            if (isInterface(body, ByteReadChannel())) {
              tmp = new (defaultTransformers$2$content$2())($this$intercept, contentType_0, body);
            } else {
              if (body instanceof OutgoingContent()) {
                tmp = body;
              } else {
                tmp = platformRequestDefaultTransform(contentType_0, $this$intercept.o4s_1, body);
              }
            }
          }
        }
        var content = tmp;
        if (!((content == null ? null : content.w47()) == null)) {
          $this$intercept.o4s_1.e5j_1.s4p('Content-Type');
          get_LOGGER().s4t('Transformed with default transformers request body for ' + $this$intercept.o4s_1.c5j_1.toString() + ' from ' + toString(getKClassFromExpression(body)));
          yield* $this$intercept.q4r(content, $completion);
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    defaultTransformers$slambdaClass = $;
  }
  return defaultTransformers$slambdaClass;
}
function defaultTransformers$slambda_0() {
  var i = new (defaultTransformers$slambda())();
  var l = ($this$intercept, body, $completion) => i.z5g($this$intercept, body, $completion);
  l.$arity = 2;
  return l;
}
var defaultTransformers$slambda$slambdaClass;
function defaultTransformers$slambda$slambda() {
  if (defaultTransformers$slambda$slambdaClass === VOID) {
    class $ {
      constructor($body, $response) {
        this.l5q_1 = $body;
        this.m5q_1 = $response;
      }
      *x59($this$writer, $completion) {
        try {
          yield* copyTo(this.l5q_1, $this$writer.s4k_1, 9223372036854775807n, $completion);
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var cause = $p;
            cancel_1(this.m5q_1, cause);
            throw cause;
          } else {
            if ($p instanceof Error) {
              var cause_0 = $p;
              cancel_0(this.m5q_1, 'Receive failed', cause_0);
              throw cause_0;
            } else {
              throw $p;
            }
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.x59(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    defaultTransformers$slambda$slambdaClass = $;
  }
  return defaultTransformers$slambda$slambdaClass;
}
function defaultTransformers$slambda$slambda_0($body, $response) {
  var i = new (defaultTransformers$slambda$slambda())($body, $response);
  var l = ($this$writer, $completion) => i.x59($this$writer, $completion);
  l.$arity = 1;
  return l;
}
var defaultTransformers$slambdaClass_0;
function defaultTransformers$slambda_1() {
  if (defaultTransformers$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_defaultTransformers) {
        this.n5q_1 = $this_defaultTransformers;
      }
      *w5h($this$intercept, _destruct__k2r9zo, $completion) {
        var info = _destruct__k2r9zo.we();
        var body = _destruct__k2r9zo.xe();
        if (!isInterface(body, ByteReadChannel()))
          return Unit_instance;
        var response = $this$intercept.o4s_1.t5h();
        var tmp0_subject = info.g4t_1;
        var tmp;
        if (tmp0_subject.equals(getKClass(Unit()))) {
          cancel(body);
          tmp = yield* $this$intercept.q4r(new (HttpResponseContainer())(info, Unit_instance), $completion);
        } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().uf())) {
          tmp = yield* $this$intercept.q4r(new (HttpResponseContainer())(info, toInt(readText(yield* readRemaining(body, $completion)))), $completion);
        } else if (tmp0_subject.equals(getKClass(Source())) || tmp0_subject.equals(getKClass(Source()))) {
          tmp = yield* $this$intercept.q4r(new (HttpResponseContainer())(info, yield* readRemaining(body, $completion)), $completion);
        } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().dg())) {
          var bytes = yield* toByteArray(body, $completion);
          checkContentLength(contentLength($this$intercept.o4s_1.t5h()), fromInt(bytes.length), $this$intercept.o4s_1.t5j().b5k());
          tmp = yield* $this$intercept.q4r(new (HttpResponseContainer())(info, bytes), $completion);
        } else if (tmp0_subject.equals(getKClass(ByteReadChannel()))) {
          var responseJobHolder = Job(response.sv().yc(Key_instance));
          // Inline function 'kotlin.also' call
          var this_0 = writer($this$intercept, this.n5q_1.f5h_1, VOID, defaultTransformers$slambda$slambda_0(body, response));
          invokeOnCompletion(this_0, (it) => {
            responseJobHolder.k12();
            return Unit_instance;
          });
          var channel = this_0.q4k_1;
          tmp = yield* $this$intercept.q4r(new (HttpResponseContainer())(info, channel), $completion);
        } else if (tmp0_subject.equals(getKClass(HttpStatusCode()))) {
          cancel(body);
          tmp = yield* $this$intercept.q4r(new (HttpResponseContainer())(info, response.j5k()), $completion);
        } else if (tmp0_subject.equals(getKClass(MultiPartData()))) {
          var tmp0 = $this$intercept.o4s_1.t5h().n51().k2o('Content-Type');
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlin.checkNotNull' call
            if (tmp0 == null) {
              var message = 'No content type provided for multipart';
              throw IllegalStateException().o(toString(message));
            } else {
              tmp$ret$2 = tmp0;
              break $l$block;
            }
          }
          var rawContentType = tmp$ret$2;
          var contentType = Companion_getInstance().gt(rawContentType);
          // Inline function 'kotlin.check' call
          if (!contentType.o4w(MultiPart_getInstance().v4v_1)) {
            var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
            throw IllegalStateException().o(toString(message_0));
          }
          var tmp1_safe_receiver = $this$intercept.o4s_1.t5h().n51().k2o('Content-Length');
          var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
          var body_0 = new (CIOMultipartDataBase())($this$intercept.sv(), body, rawContentType, contentLength_0);
          var parsedResponse = new (HttpResponseContainer())(info, body_0);
          tmp = yield* $this$intercept.q4r(parsedResponse, $completion);
        } else {
          tmp = null;
        }
        var result = tmp;
        if (!(result == null)) {
          get_LOGGER().s4t('Transformed with default transformers response body ' + ('for ' + $this$intercept.o4s_1.t5j().c5k().toString() + ' to ' + toString(info.g4t_1)));
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.w5h(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    defaultTransformers$slambdaClass_0 = $;
  }
  return defaultTransformers$slambdaClass_0;
}
function defaultTransformers$slambda_2($this_defaultTransformers) {
  var i = new (defaultTransformers$slambda_1())($this_defaultTransformers);
  var l = ($this$intercept, _destruct__k2r9zo, $completion) => i.w5h($this$intercept, _destruct__k2r9zo, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_DefaultTransform_kt_ossax9;
function _init_properties_DefaultTransform_kt__20knxx() {
  if (!properties_initialized_DefaultTransform_kt_ossax9) {
    properties_initialized_DefaultTransform_kt_ossax9 = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
  }
}
//region block: exports
export {
  defaultTransformers as defaultTransformers2r9wd7ftt31zw,
};
//endregion

//# sourceMappingURL=DefaultTransform.mjs.map
